<app-three-column-template
  [pageData]="pageData"
  [showLoader]="true"
  [showTags]="false"
  [hasCustomMain]="true"
  [hasCustomTitle]="true">

  <div class="title-section" slot="custom-title">
    <div class="item-title">
      <span (click)="goBack()"
            class="back icon-CaretLeft"></span>{{ 'Related items'|translate }}
    </div>

    <div class="item-subtitle">
      {{ 'Explore more news articles related to'|translate }} “<span
      class="item-subtitle-title"> {{ prevTitle }} </span>”
    </div>
    <div class="item-count">{{ pageData?.items?.totalCount }} {{ 'items found'|translate }}</div>
  </div>

  @if (pageData?.items?.items?.length) {
    @for (relatedItem of pageData?.items?.items; track relatedItem.id; let isLast = $last) {
      <app-publication-card [hasDesc]="true"
                            [cardType]="PublicationsType.RELATED"
                            [isLast]="isLast"
                            [publicationData]="relatedItem"></app-publication-card>
    }
  }

  @if (pageData?.items?.items?.length) {
    <app-paginator
      [totalRecords]="pageData?.items?.totalCount || 0"
      slot="pagination"></app-paginator>
  }

</app-three-column-template>
